import React, {useEffect, useRef} from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import {black, hover, text, white} from "../styles/globalStyleVars";
import {Link} from "react-router-dom";
import ReactHtmlParser from "react-html-parser";

const MyComponent = ({data}) => {


    const containerRef = useRef();

    useEffect(() => {
        localStorage.setItem('containeroffset', containerRef.current.offsetLeft)
    }, [])

    return (
        <StyledComponent className={'footer pt-80'}>
            <Container ref={containerRef}>
                <Row>
                    <Col sm={3} >
                        <a className={'call'} href={`tel:${data?.phone}`}>{data?.phone}</a>
                        <a className={'mail'} href={`mailto:${data?.email}`}>{data?.email}</a>
                        {/*<a className={'underline-btn'} href="/"> Download Brochure</a>*/}
                        <div className={'social-icon'}>
                            <ul>
                                {
                                    data?.facebook &&
                                    <li><a className={'hover'} href={data?.facebook} target={"_blank"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="7.847" height="14.65"
                                             viewBox="0 0 7.847 14.65">
                                            <path id="Path_2115" data-name="Path 2115"
                                                  d="M1206.12,104.34l.406-2.652h-2.544v-1.72a1.325,1.325,0,0,1,1.495-1.432h1.157V96.278a14.1,14.1,0,0,0-2.053-.179,3.237,3.237,0,0,0-3.465,3.569v2.021h-2.329v2.652h2.329v6.409h2.866V104.34Z"
                                                  transform="translate(-1198.787 -96.099)" fill="#fff"/>
                                        </svg>

                                    </a></li>
                                }

                                {
                                    data?.twitter &&
                                    <li><a className={'hover'} href={data?.twitter}
                                           target={"_blank"}>
                                        <svg id="layer1" xmlns="http://www.w3.org/2000/svg" width="11.035"
                                             height="10.329"
                                             viewBox="0 0 11.035 10.329">
                                            <path id="path1009"
                                                  d="M281.527,167.31l4.26,5.7-4.287,4.632h.965l3.754-4.055,3.033,4.055h3.284l-4.5-6.017,3.991-4.311h-.965l-3.457,3.735-2.793-3.735Zm1.419.711h1.509l6.661,8.907h-1.509Z"
                                                  transform="translate(-281.5 -167.31)" fill="#fff"/>
                                        </svg>

                                    </a></li>
                                }

                                {
                                    data?.instagram &&
                                    <li><a className={'hover'} href={data?.instagram}
                                           target={"_blank"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="11.186" height="11.186"
                                             viewBox="0 0 11.186 11.186">
                                            <g id="Group_13724" data-name="Group 13724"
                                               transform="translate(-2167 -9029)">
                                                <path id="Path_5912" data-name="Path 5912"
                                                      d="M5.593,1.008c1.493,0,1.67.006,2.26.033a3.093,3.093,0,0,1,1.038.193,1.733,1.733,0,0,1,.643.418,1.733,1.733,0,0,1,.418.643,3.1,3.1,0,0,1,.193,1.038c.027.59.033.767.033,2.26s-.006,1.67-.033,2.26a3.1,3.1,0,0,1-.193,1.038A1.852,1.852,0,0,1,8.891,9.953a3.093,3.093,0,0,1-1.038.193c-.59.027-.767.033-2.26.033s-1.67-.006-2.26-.033a3.093,3.093,0,0,1-1.038-.193,1.733,1.733,0,0,1-.643-.418,1.733,1.733,0,0,1-.418-.643A3.093,3.093,0,0,1,1.04,7.853c-.027-.59-.033-.767-.033-2.26s.006-1.67.033-2.26a3.093,3.093,0,0,1,.193-1.038,1.733,1.733,0,0,1,.418-.643,1.733,1.733,0,0,1,.643-.418A3.093,3.093,0,0,1,3.333,1.04c.59-.027.767-.033,2.26-.033M5.593,0C4.074,0,3.883.006,3.287.034a4.106,4.106,0,0,0-1.358.26A2.741,2.741,0,0,0,.939.939a2.741,2.741,0,0,0-.645.991,4.106,4.106,0,0,0-.26,1.358C.006,3.883,0,4.074,0,5.593S.006,7.3.034,7.9a4.106,4.106,0,0,0,.26,1.358,2.741,2.741,0,0,0,.645.991,2.743,2.743,0,0,0,.991.645,4.106,4.106,0,0,0,1.358.26c.6.027.787.034,2.306.034S7.3,11.179,7.9,11.152a4.106,4.106,0,0,0,1.358-.26,2.86,2.86,0,0,0,1.636-1.636,4.106,4.106,0,0,0,.26-1.358c.027-.6.034-.787.034-2.306s-.006-1.709-.034-2.306a4.106,4.106,0,0,0-.26-1.358,2.743,2.743,0,0,0-.645-.991A2.741,2.741,0,0,0,9.256.294,4.106,4.106,0,0,0,7.9.034C7.3.006,7.112,0,5.593,0"
                                                      transform="translate(2167 9029)" fill="#fff"/>
                                                <path id="Path_5913" data-name="Path 5913"
                                                      d="M23.548,20.676a2.872,2.872,0,1,0,2.872,2.872,2.872,2.872,0,0,0-2.872-2.872m0,4.736a1.864,1.864,0,1,1,1.864-1.864,1.864,1.864,0,0,1-1.864,1.864"
                                                      transform="translate(2149.045 9011.045)" fill="#fff"/>
                                                <path id="Path_5914" data-name="Path 5914"
                                                      d="M61.429,15.384a.671.671,0,1,1-.671-.671.671.671,0,0,1,.671.671"
                                                      transform="translate(2114.82 9016.224)" fill="#fff"/>
                                            </g>
                                        </svg>


                                    </a></li>
                                }

                                {
                                    data?.linkedin &&
                                    <li><a className={'hover'} href={data?.linkedin}
                                           target={"_blank"}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12.063" height="10.561"
                                             viewBox="0 0 9.063 8.561">
                                            <path id="LinkedIn"
                                                  d="M1096.5,3921.554v3.313h-1.942v-3.091c0-.776-.281-1.306-.984-1.306a1.061,1.061,0,0,0-1,.7,1.3,1.3,0,0,0-.065.469v3.226h-1.943s.026-5.234,0-5.777h1.943v.82l-.013.018h.013v-.018a1.932,1.932,0,0,1,1.751-.955C1095.539,3918.955,1096.5,3919.781,1096.5,3921.554Zm-7.964-5.249a1,1,0,1,0-.026,2h.013a1,1,0,1,0,.013-2Zm-.984,8.561h1.943v-5.777h-1.943Z"
                                                  transform="translate(-1087.435 -3916.306)" fill="#fff"></path>
                                        </svg>
                                    </a></li>
                                }

                                {
                                    data?.youtube &&
                                    <li><a href={data?.youtube} target={"_blank"}
                                           className={'hover'} target={'_blank'}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="12.822" height="8.975"
                                             viewBox="0 0 12.822 8.975">
                                            <path id="Path_2114" data-name="Path 2114"
                                                  d="M1146.9,113.13a2.813,2.813,0,0,0-2.813-2.813h-7.195a2.813,2.813,0,0,0-2.813,2.813v3.348a2.813,2.813,0,0,0,2.813,2.813h7.195a2.813,2.813,0,0,0,2.813-2.813Zm-4.231,1.925-3.226,1.6c-.126.068-.556-.023-.556-.167v-3.276c0-.146.433-.237.56-.165l3.089,1.68C1142.661,114.8,1142.8,114.985,1142.666,115.056Z"
                                                  transform="translate(-1134.075 -110.317)" fill="#fff"/>
                                        </svg>
                                    </a></li>
                                }


                            </ul>
                        </div>
                    </Col>

                    <Col sm={{span: 8, offset: 1}} className={'footer__content'}>
                        <Row>
                            {
                                data?.head_office_address && data?.head_office_address_url &&
                                <Col sm={5} className={'offices'}>
                                    <p>Head Office</p>
                                    <p>{ReactHtmlParser(data?.head_office_address)}</p>
                                    <a target={'_blank'} className={'underline-btn'}
                                       href={data?.head_office_address_url}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
                                            <g id="Group_15840" data-name="Group 15840" transform="translate(-919 2586)">
                                                <g id="Group_15839" data-name="Group 15839"
                                                   transform="translate(263 -9577)">
                                                    <g id="Ellipse_217" data-name="Ellipse 217"
                                                       transform="translate(656 6991)" fill="none" stroke="#b8b8b8"
                                                       stroke-width="1" opacity="0.5">
                                                        <circle cx="17.5" cy="17.5" r="17.5" stroke="none"/>
                                                        <circle cx="17.5" cy="17.5" r="17" fill="none"/>
                                                    </g>
                                                    <g id="Icons" transform="translate(658.466 6995.958)">
                                                        <path id="Path_2220" data-name="Path 2220"
                                                              d="M15.034,5a6.034,6.034,0,0,0-4.465,10.092l4.179,4.861a.377.377,0,0,0,.573,0L19.5,15.092A6.034,6.034,0,0,0,15.034,5Zm3.892,9.6-3.892,4.529-3.892-4.526a5.28,5.28,0,1,1,7.784,0Z"
                                                              fill="#fff"/>
                                                        <path id="Path_2221" data-name="Path 2221"
                                                              d="M20.64,14a2.64,2.64,0,1,0,2.64,2.64A2.64,2.64,0,0,0,20.64,14Zm0,4.526a1.886,1.886,0,1,1,1.886-1.886,1.886,1.886,0,0,1-1.886,1.886Z"
                                                              transform="translate(-5.606 -5.606)" fill="#fff"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>Get Directions</span></a>
                                </Col>
                            }


                            {
                                data?.branch_office_address && data?.branch_office_address_url &&
                                <Col sm={{span: 5, offset: 2}}>
                                    <p>Branch Office</p>
                                    <p>{ReactHtmlParser(data?.branch_office_address)}</p>


                                    <a className={'underline-btn'} target={'_blank'}
                                       href={data?.branch_office_address_url}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
                                            <g id="Group_15840" data-name="Group 15840" transform="translate(-919 2586)">
                                                <g id="Group_15839" data-name="Group 15839"
                                                   transform="translate(263 -9577)">
                                                    <g id="Ellipse_217" data-name="Ellipse 217"
                                                       transform="translate(656 6991)" fill="none" stroke="#b8b8b8"
                                                       stroke-width="1" opacity="0.5">
                                                        <circle cx="17.5" cy="17.5" r="17.5" stroke="none"/>
                                                        <circle cx="17.5" cy="17.5" r="17" fill="none"/>
                                                    </g>
                                                    <g id="Icons" transform="translate(658.466 6995.958)">
                                                        <path id="Path_2220" data-name="Path 2220"
                                                              d="M15.034,5a6.034,6.034,0,0,0-4.465,10.092l4.179,4.861a.377.377,0,0,0,.573,0L19.5,15.092A6.034,6.034,0,0,0,15.034,5Zm3.892,9.6-3.892,4.529-3.892-4.526a5.28,5.28,0,1,1,7.784,0Z"
                                                              fill="#fff"/>
                                                        <path id="Path_2221" data-name="Path 2221"
                                                              d="M20.64,14a2.64,2.64,0,1,0,2.64,2.64A2.64,2.64,0,0,0,20.64,14Zm0,4.526a1.886,1.886,0,1,1,1.886-1.886,1.886,1.886,0,0,1-1.886,1.886Z"
                                                              transform="translate(-5.606 -5.606)" fill="#fff"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <span>Get Directions</span></a>
                                </Col>
                            }


                            <Col sm={12}>
                                <div className="footer__content__menu">
                                    <ul>
                                        <li ><Link to="/"><a>Home</a></Link></li>
                                        <li><Link to="/about"><a>About Us</a></Link></li>
                                        <li><Link to="/projects"><a>Projects</a></Link></li>
                                        <li><Link to="/equipments"><a>Equipments</a></Link></li>
                                        <li><Link to="/contact"><a>Contact</a></Link></li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="footer-bottom">
                            <Row>
                                <Col sm={3}>
                                    <p>© {new Date().getFullYear()} UCC Infrastructure. All Rights Reserved</p>
                                </Col>
                                <Col sm={{span: 6, offset: 1}}>
                                    <div>
                                        <p className={'d-flex'}>
                                            Designed & Developed by <a href='https://dcastalia.com/' target='_blank'>
                                            Dcastalia
                                        </a>
                                       </p>

                                    </div>

                                </Col>

                            </Row>

                        </div>

                    </Col>
                </Row>

            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
  background-color: ${black};
  border-top: 1px solid rgba(255, 255, 255, 0.2);


  a {
    display: block;
  }

  .offices {
    p {
      &:first-child {
        color: ${text};
      }
    }
  }

  .social-icon {
    ul {
      margin-top: 30px;
      display: flex;

      li {
        a {
          height: 25px;
          width: 25px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &:not(:nth-last-of-type(1)) {
          margin-right: 15px;
        }
      }
    }

  }

  .call {
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    color: #ffffff;
    margin-bottom: 16px;
  }

  .mail {
    font-size: 16px;
    line-height: 24px;
    color: #f2f0f0;

  }

  .underline-btn {
    margin-top: 40px;
    font-size: 16px;
    line-height: 24px;
    //text-transform: uppercase;
    color: #ffffff !important;
    position: relative;
    width: fit-content;
    padding-bottom: 5px;
    display: flex;
    align-items: center;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 100%;
      background-color: #fff;
      transition: all 0.3s ease;

    }

    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      width: 0;
      opacity: 0;
      background-color: ${hover};
      transition: all 1s cubic-bezier(0.4, 0, 0, 1);
    }

    &:hover:before {
      height: 4px;
      background-color: ${text};
    }
  }

  h4 {
    color: #ffffff;
    margin-bottom: 12px;
    font-size: 14px;
    text-transform: uppercase;
    line-height: 18px;
  }

  p {
    color: ${white};
    margin-bottom: 10px;
  }

  .footer__content {
    svg {
      margin-right: 20px;
    }

    .underline-btn {
      &:before, &:after {
        display: none;
      }

      span {
        position: relative;
        //display: block;
        color: #ffffff;
        padding-bottom: 5px;
        //
        //&:before {
        //  content: '';
        //  position: absolute;
        //  left: 0;
        //  bottom: 0;
        //  height: 1px;
        //  width: 100%;
        //  background-color: #fff;
        //  transition: all 0.3s ease;
        //}

        &:after {
          //content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          height: 1px;
          width: 0;
          background-color: ${hover};
          transition: all 1s cubic-bezier(0.4, 0, 0, 1);
        }
      }

      &:hover span {
        &:before {
          height: 4px;
        }
      }
    }

    &__menu {
      margin-top: 80px;
      border-top: 1px solid rgba(184, 184, 184, 0.30);
      padding-top: 40px;
      padding-bottom: 80px;

      ul {
        display: flex;

        li {
          a {
            font-size: 16px;
            line-height: 20px;
            color: ${white};
            display: block;
            padding: 5px 30px 5px 0;
            //text-transform: uppercase;
            //letter-spacing: 2px;
            white-space: nowrap;
          }

          &:nth-last-of-type(1) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .footer-bottom {
    border-top: 1px solid rgba(184, 184, 184, 0.30);
    padding-top: 20px;
    padding-bottom: 35px;

    p, a {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 0;
      
    }
    a{
      margin-left: 5px;
      &:hover{
        color: ${hover} !important;
      }

    }
    
  }

  @media (max-width: 991px) {
    .col-sm-3 {
      min-width: 100%;
    }

    .footer__content {
      min-width: 100%;
      margin: 50px 0 0 0;
    }

    .footer-bottom {
      .col-sm-3, .col-sm-6, .col-sm-2 {
        min-width: 33.333%;
        max-width: 33.333%;
        margin: 0;
      }
    }
  }

  @media (max-width: 767px) {
    .footer-bottom {
      .col-sm-3, .col-sm-6, .col-sm-2 {
        min-width: 100%;
        max-width: 100%;
      }
    }
  }

  @media (max-width: 600px) {
    .underline-btn {
      margin-top: 30px;
    }

    p {
      margin-bottom: 20px;
    }

    .col-sm-5:not(:nth-last-of-type(2)) {
      margin-bottom: 40px;
    }

    .footer__content__menu {
      padding-bottom: 40px;

      ul {
        flex-wrap: wrap;

        li {
          min-width: 100%;

          &:not(:nth-last-of-type(1)) {
            margin-bottom: 16px;
          }
        }
      }
    }
  }

`;

export default MyComponent;
